function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9718 35.5L35.4925 13.9793L57.0132 35.5L35.4925 57.0207L13.9718 35.5Z",
  fill: "#629F8B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.024 35.5L35.5 13.9761V57.024L57.024 35.5Z",
  fill: "#3A6F5D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M71 35.5C71 36.0408 70.792 36.5816 70.3758 36.9559L36.9559 70.3758C36.5816 70.792 36.0408 71 35.5 71L31.3398 59.4209L35.5 51.1422L51.1422 35.5L58.8114 31.3398L71 35.5Z",
  fill: "#092D21"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 0L39.6602 11.5791L35.5 19.8578L19.8578 35.5L10.2302 39.6602L0 35.5C0 34.9592 0.208008 34.4184 0.624162 34.0441L34.0441 0.624162C34.4184 0.208008 34.9592 0 35.5 0V0Z",
  fill: "#357761"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 51.1422V71C34.9592 71 34.4184 70.792 34.0441 70.3758L0.624162 36.9559C0.208008 36.5816 0 36.0408 0 35.5H19.8578L35.5 51.1422Z",
  fill: "#205543"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M71 35.5H51.1422L35.5 19.8578V0C36.0408 0 36.5816 0.208008 36.9559 0.624162L70.3758 34.0441C70.792 34.4184 71 34.9592 71 35.5Z",
  fill: "#205543"
});

function SvgFinpalDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinpalDark);
export default __webpack_public_path__ + "static/media/finpal-dark.610fad3e.svg";
export { ForwardRef as ReactComponent };